import { createContext, useContext } from 'react';

/**
 * Squeeze state for the resizable label panel that deep row cells need to react
 * to — currently just whether the STATUS pill has collapsed to a colored
 * circle. Passed via context (not props) so the memoized group/task rows and
 * the sticky-header copies don't all need new signatures; the boolean flips
 * only at the width threshold, so consumers re-render rarely, not per drag
 * frame. Column *widths* are driven by CSS custom properties, not this context.
 */
export interface ILabelSqueeze {
  asStatusCircle: boolean;
}

const DEFAULT: ILabelSqueeze = { asStatusCircle: false };

export const LabelSqueezeContext = createContext<ILabelSqueeze>(DEFAULT);

/** Read the label-squeeze state. Defaults to "no squeeze" outside a provider. */
export function useLabelSqueeze(): ILabelSqueeze {
  return useContext(LabelSqueezeContext);
}
